import { Formik } from 'formik';
import { SearchOutlined } from '@ant-design/icons';
import classNames from 'classnames';

import { Input, Button, Pagination, BaseTable } from '../..';

import styles from './index.module.css';
import { useRiderBulkImportModal } from '../../modals/RiderBulkImport/riderBulkImportModal';
import { URLS } from '../../../constants/constants';

export const EntitiesTableList = ({
  title,
  addNewBtnTitle,
  Navigation,
  data,
  columns,
  handleChangePage,
  handleRowClick,
  limit,
  currentPage,
  total,
  totalPages,
  showAddNewButton,
  showAddNewAdminButton,
  showBulkImportButton,
  showImportStatusButton,
  addHoverEffectToRowTable,
  handleChangeSearch,
  searchValue,
  searchPlaceholder = 'Search by name or email',
  handleConfirmImport
}) => {
  const navigate = Navigation;

  const { Modal, setImportModalVisible } = useRiderBulkImportModal({
    onConfirm: handleConfirmImport
  });

  const toggleImportModal = (flag) => () => setImportModalVisible(flag);

  return (
    <>
      <div className={styles.pageContent}>
        <div className={styles.pageTitle}>
          <h1 className={styles.title}>{title}</h1>
          <Formik
            enableReinitialize
            initialValues={{ searchInput: searchValue }}
          >
            {({ setFieldValue }) => (
              <div className={styles.inputField}>
                <Input
                  type="text"
                  name="searchInput"
                  onChange={handleChangeSearch}
                  prefix={<SearchOutlined className={styles.searchIcon} />}
                  placeholder={searchPlaceholder}
                  allowClear
                  myClassName={styles.inputFieldWidth}
                />
              </div>
            )}
          </Formik>

          {showAddNewAdminButton && (
            <div className={[styles.addOrganization, styles.add].join(' ')} >
              <Button
                myClassName={styles.addOrganizationBtn}
                onClick={() => {
                  navigate.push(`${navigate?.location.pathname}/admin/new`, {
                    from: navigate?.location.pathname,
                  });
                }}
              > Add New Admin
              </Button>
            </div>
          )}

          {showAddNewButton && (
            <div className={[styles.addOrganization, styles.add].join(' ')}>
              <Button
                myClassName={styles.addOrganizationBtn}
                onClick={() =>
                  navigate.push(`${navigate?.location.pathname}/new`, {
                    from: navigate?.location.pathname,
                  })
                }
              >
                {addNewBtnTitle}
              </Button>
            </div>
          )}

          {showBulkImportButton &&
            <div className={[styles.addOrganization, styles.add].join(' ')} >
              <Button
                myClassName={styles.addOrganizationBtn}
                onClick={toggleImportModal(true)}
              > Import Riders
              </Button>
            </div>
          }

          {showImportStatusButton > 0 && (
            <div className={[styles.addOrganization, styles.add].join(' ')} >
              <Button
                myClassName={styles.addOrganizationBtn}
                onClick={() => {
                  navigate.push(URLS.RIDERS_IMPORT, {
                    from: navigate?.location.pathname,
                  });
                }}
              > Import Status
              </Button>
            </div>
          )}
        </div>

        <div
          className={classNames({
            [styles.tableWrapper]: true,
            [styles.ridersTable]: addHoverEffectToRowTable,
          })}
        >
          <BaseTable
            data={data}
            columns={columns}
            onRowClick={handleRowClick}
          />
        </div>
      </div>

      {Modal}

      <div
        className={classNames({
          [styles.pagination]: true,
          [styles.gapForPagination]: data?.length > 6,
        })}
      >
        <Pagination
          defaultCurrent={currentPage}
          total={total}
          totalPages={totalPages}
          onChange={handleChangePage}
          pageSize={limit}
        />
      </div>
    </>
  );
};
